import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getSearchText } from '../selectors';
import * as searchActions from '../actions';
import { UploadData } from '../model';

export function useUpdateState() {
  const dispatch = useDispatch();
  const timeoutRef = useRef<number>();

  const appliedText = useSelector(getSearchText);
  const [text, setText] = useState(appliedText);
  useEffect(() => {
    setText(appliedText);
  }, [appliedText]);

  const updateState = useCallback(
    (data: { text: string; uploadData: UploadData | undefined; debounce?: boolean }) => {
      clearTimeout(timeoutRef.current);
      setText(data.text);
      const fn = () =>
        dispatch(searchActions.queryChanged({ text: data.text, uploadData: data.uploadData }));

      if (data.debounce) {
        timeoutRef.current = window.setTimeout(fn, 500);
      } else {
        fn();
      }
    },
    [setText, dispatch],
  );

  return { text, updateState };
}
